/**
 * @class Cookies
 * A class for URBN-A15 cookie related operations
 */
class Cookies {

    /**
     * Get Cookie By Name
     * Retrieves a cookie by name
     * c_name: name of the cookie you want to find the value for
     */
    getCookieByName(c_name) {
        if(document.cookie.length > 0) {
            let c_end;
            let c_start = document.cookie.indexOf(c_name + "=");
            if(c_start !== -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if(c_end === -1) {
                    c_end = document.cookie.length;
                }
                return document.cookie.substring(c_start, c_end);
            }
        }
        return "";
    }

    /**
     * Set Cookie
     * Sets or creates a cookie
     * name: the name of the cookie you want to set or create
     * value: the value you want to store in the above-named cookie
     * secs: the expiration time for the cookie, in seconds
     */
    setCookie(name, value, secs) {
        let expires;
        if(secs) {
            let date = new Date(Date.now() + secs * 1000);
            date = date.toGMTString();
            expires = "; expires=" + date;
        }
        else {
            expires = '';
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    /**
     * Delete Cookie
     */
    deleteCookie(name) {
        this.setCookie(name, '', -1);
    }
}

const cookies = new Cookies();

export default cookies;
